import { axiosInstance } from "@/utilities";
import { API_BASE_URL } from "@/services/XCONS_ENV";
import {
  FiservConfig,
  GetnetConfig,
  InstructionsPaymentConfig,
  MercadoPagoConfig,
  PaymentMethodCode,
} from "./types";

const base = (sellerCode: string) =>
  `${API_BASE_URL}/sellers/${encodeURIComponent(sellerCode)}/payments/methods`;

// Instructions-only methods (purchase-order, bank-transfer, check-money)
export async function getInstructionsMethod(
  sellerCode: string,
  code: 'purchase-order' | 'bank-transfer' | 'check-money',
): Promise<InstructionsPaymentConfig> {
  const { data } = await axiosInstance.get<InstructionsPaymentConfig>(`${base(sellerCode)}/${code}`);
  return data;
}

export async function upsertInstructionsMethod(
  sellerCode: string,
  code: 'purchase-order' | 'bank-transfer' | 'check-money',
  payload: InstructionsPaymentConfig,
): Promise<InstructionsPaymentConfig> {
  const { data } = await axiosInstance.put<InstructionsPaymentConfig>(
    `${base(sellerCode)}/${code}`,
    payload,
  );
  return data;
}

// Getnet
export async function getGetnet(sellerCode: string): Promise<GetnetConfig> {
  const { data } = await axiosInstance.get<GetnetConfig>(`${base(sellerCode)}/getnet`);
  return data;
}

export async function upsertGetnet(sellerCode: string, payload: GetnetConfig): Promise<GetnetConfig> {
  const { data } = await axiosInstance.put<GetnetConfig>(`${base(sellerCode)}/getnet`, payload);
  return data;
}

// MercadoPago
export async function getMercadoPago(sellerCode: string): Promise<MercadoPagoConfig> {
  const { data } = await axiosInstance.get<MercadoPagoConfig>(`${base(sellerCode)}/mercadopago`);
  return data;
}

export async function upsertMercadoPago(
  sellerCode: string,
  payload: MercadoPagoConfig,
): Promise<MercadoPagoConfig> {
  const { data } = await axiosInstance.put<MercadoPagoConfig>(
    `${base(sellerCode)}/mercadopago`,
    payload,
  );
  return data;
}

// Fiserv
export async function getFiserv(sellerCode: string): Promise<FiservConfig> {
  const { data } = await axiosInstance.get<FiservConfig>(`${base(sellerCode)}/fiserv`);
  return data;
}

export async function upsertFiserv(sellerCode: string, payload: FiservConfig): Promise<FiservConfig> {
  const { data } = await axiosInstance.put<FiservConfig>(`${base(sellerCode)}/fiserv`, payload);
  return data;
}

// List configured (for badges/status)
export async function listPaymentMethods(
  sellerCode: string,
): Promise<{ code: PaymentMethodCode; enabled: boolean }[]> {
  const { data } = await axiosInstance.get<{ code: PaymentMethodCode; enabled: boolean }[]>(
    `${base(sellerCode)}`,
  );
  return data;
}
